import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IFilterItemViewModel, IImage, ILayoutSettings } from '@ncg/data';

import { ImageUrl } from '../../utils/helpers/image-helper';
import { ProductImagePipe } from '../../utils/product-image.pipe';

@Component({
    selector: 'ncg-product-item',
    template: `
        <article class="product-item" [ngClass]="layout?.view === 'grid' ? 'is-grid-view' : 'is-list-view'">
            <div class="columns is-mobile is-gapless" [class.is-multiline]="layout?.view === 'grid'">
                <div class="product-item__media column is-relative" [ngClass]="layout?.view === 'grid' ? 'is-full' : 'is-flex-shrink-0'">
                    <div class="product-item__media-tags">
                        <ncg-product-item-tags [item]="item"></ncg-product-item-tags>
                    </div>
                    <div class="product-item__media-wrapper is-ratio-product-item">
                        <ncg-product-item-carousel
                            *ngIf="hasCarousel"
                            [itemId]="item.id"
                            [view]="layout?.view"
                            [productUrl]="item.productUrl"
                            [pictures]="images"
                        ></ncg-product-item-carousel>

                        <a [routerLink]="[item.productUrl]" *ngIf="!hasCarousel && fallbackSrc" class="product-item-carousel__link">
                            <picture class="product-item__media--empty">
                                <source [srcset]="fallbackSrcSet" />
                                <img [alt]="fallbackAlt" [src]="fallbackSrc" width="690" height="460" sizes="100vw" loading="lazy" />
                                <h3 class="product-item__media-wrapper--empty-text level level-item" *ngIf="isFallback">
                                    {{ 'product_details.gallery_placeholder' | translate }}
                                </h3>
                            </picture>
                        </a>
                    </div>
                </div>

                <a [routerLink]="[item.productUrl]" class="column product-item__link" [ngClass]="layout?.view === 'grid' ? 'is-full' : ''">
                    <div class="product-item__header">
                        <div class="product-item__header-container">
                            <h3 class="product-item__title">{{ item.title }}</h3>
                            <ncg-favorite-button class="product-item__favorite-button is-hidden-tablet" [item]="item"></ncg-favorite-button>
                            <div class="product-item__subtitle">
                                <div *ngIf="item.variant">{{ item.variant }}</div>
                            </div>
                        </div>
                        <div class="product-item__header-price is-hidden-mobile">
                            <ncg-product-item-price [item]="item"> </ncg-product-item-price>
                        </div>
                    </div>
                    <div class="product-item__content">
                        <ncg-product-item-content [item]="item"></ncg-product-item-content>
                        <div class="is-hidden-tablet is-hidden-desktop" [ngClass]="layout?.view === 'grid' ? '' : 'is-flex is-justify-content-end'">
                            <ncg-product-item-price [item]="item"></ncg-product-item-price>
                        </div>
                        <ncg-favorite-button class="product-item__favorite-button is-hidden-mobile" [item]="item"></ncg-favorite-button>
                    </div>
                </a>
            </div>
        </article>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemComponent implements OnInit {
    @Input() item: IFilterItemViewModel;
    @Input() fallbackImage?: IImage;
    @Input() layout?: ILayoutSettings;
    get images(): string[] {
        return this.item?.pictures || [];
    }
    get hasCarousel(): boolean {
        return this.images.length > 1;
    }
    fallbackSrcSet: string = '';
    fallbackSrc = '';
    fallbackAlt = '';
    isFallback = false;

    constructor(private readonly productImagePipe: ProductImagePipe) {}

    ngOnInit() {
        const images = this.images;
        if (images.length) {
            this.fallbackSrcSet = `
                    ${this.productImagePipe.transform(images[0], 'small')} 1x,
                    ${this.productImagePipe.transform(images[0], 'medium')} 2x
                `;
            this.fallbackSrc = this.productImagePipe.transform(images[0], 'small');
            this.fallbackAlt = `${this.item.title} ${this.item.variant || ''} ${this.item.year || ''}`.trim();
        } else if (this.fallbackImage) {
            this.isFallback = true;
            this.fallbackSrcSet = `
                ${ImageUrl(this.fallbackImage, { width: 690, height: 460, mode: 'crop' })} 1x,
                ${ImageUrl(this.fallbackImage, { width: 1380, height: 920, mode: 'crop' })} 2x
                `;
            this.fallbackSrc = ImageUrl(this.fallbackImage, { width: 690, height: 460, mode: 'crop' });
            this.fallbackAlt = this.fallbackImage.altText || '';
        }
    }
}
